import type { FunctionComponent } from "react";
import type { IPagination } from "../types/models/pagination.models.types";
import Spinner from "./spinner.components";
import { Button } from "./ui/button";

interface IProps {
	fetching: boolean;
	paginationData: IPagination;
	onClick: () => void;
}

const PaginationComponent: FunctionComponent<IProps> = ({
	fetching,
	paginationData,
	onClick,
}) => {
	return (
		<div className="flex justify-center items-center">
			{paginationData.page < paginationData.totalPages ? (
				fetching ? (
					<div className="flex justify-center items-start mt-10 h-10">
						<Spinner width={20} />
					</div>
				) : (
					<Button
						onClick={onClick}
						className="bg-tertiarybuttonbg mt-10 border border-border font-semibold text-xs"
					>
						Load more +
					</Button>
				)
			) : null}
		</div>
	);
};

export default PaginationComponent;
